
import React, { useEffect, useState, useRef } from 'react';
// import './Header.css';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

const Dist_Month_RO_Report_data = async (params) => {
  const response = await fetch(`${process.env.REACT_APP_URL_SIDE}/api/AnnavitranState`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(params),
  });
  if (!response.ok) {
    throw new Error('Failed to fetch data');
  }
  return response.json();
};

const AnnavitranTransReport = ({ month, year }) => {
  const [reportData, setReportData] = useState([]);
  const [commoditycodeBean, setCommoditycodeBean] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [tabHeading, setTabHeading] = useState(null);
  const [renderContentt, setRenderContentt] = useState(null);
  const detailsRRef = useRef(null);

  useEffect(() => {
    const getData = async () => {
      try {
        const response_data = await Dist_Month_RO_Report_data({ month, year });

        setTabHeading(response_data.heading);

        if (response_data.data && response_data.data.length > 0) {
          setReportData(response_data.data[0]);

          // Dynamically extract commodities from the response
          const commodities = response_data.data.reduce((acc, item) => {
            item.commoditycodeBean?.forEach(commodity => {
              if (!acc.some(existing => existing.cmm === commodity.cmm)) {
                acc.push(commodity);
              }
            });
            return acc;
          }, []);

          setCommoditycodeBean(commodities);
        } else {
          setReportData([]);
        }

      } catch (error) {
        setError(error);
      } finally {
        setLoading(false);
      }
    };

    getData();
  }, [month, year]); // Added dependencies

  useEffect(() => {
    if (!loading && !error && reportData.length > 0 && detailsRRef.current) {
      detailsRRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }, [loading, error, reportData]);

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <Box sx={{ display: 'flex' }}>
          <CircularProgress />
        </Box>
      </div>
    );
  }

  if (error) {
    return (
      <div className="mainhead" align="center">
        Internal Error
      </div>
    );
  }

  if (!reportData || reportData.length === 0) {
    return (
      <div className="mainhead" align="center">
        No data found
      </div>
    );
  }


  return (
    <>
      <table id="myTable" align="center" width="40%" border={1}>
        {/* <thead>
                    <tr className="tableheader">
                        <th colSpan={3}>{tabHeading}</th>
                    </tr>
                </thead> */}
        <tbody>
          {reportData && (
            <React.Fragment>
              <tr className="" style={{ width: "50", border: '1px solid black' }}>
                <td align="center">
                  <u>District</u><br />
                  {reportData.dist_count}
                </td>
                <td align="center">
                  <u>Total FPS</u><br />
                  {reportData.fps_count}
                </td>
                <td align="center">
                  <u>Valid Devices</u><br />
                  {reportData.device_count}
                </td>
              </tr>

              <tr className="tableheader">
                <td colSpan={3} align="center">Total</td>
              </tr>

              <tr>
                <td align="center">
                  <u>Trans</u><br />
                  {reportData.total_trans || "0"}
                </td>
                <td align="center">
                  <u>Cards</u><br />
                  {reportData.cards || "0"}
                </td>
                <td align="center">
                  <u>Today Trans</u><br />
                  {reportData.today || "0"}
                </td>
              </tr>

              <tr className="tableheader">
                <td style={{ textAlign: 'center' }}>Scheme</td>
                <td style={{ textAlign: 'center' }}>Nfsa Ration Cards</td>
                <td style={{ textAlign: 'center' }}>% NFSA RATION CARDS&nbsp;</td>
              </tr>

              <tr>
                <td style={{ textAlign: 'center' }}>NFSA-PHH</td>
                <td style={{ textAlign: 'right' }}>{reportData.rc_nfsa_phh}</td>
                <td style={{ textAlign: 'right' }}>
                  {reportData.rc_tot
                    ? ((parseFloat(reportData.rc_nfsa_phh) * 100) / parseFloat(reportData.rc_tot)).toFixed(2) + '%'
                    : '0%'}
                </td>
              </tr>

              <tr>
                <td style={{ textAlign: 'center' }}>NFSA-AAY</td>
                <td style={{ textAlign: 'right' }}>{reportData.rc_nfsa_aay}</td>
                <td style={{ textAlign: 'right' }}>
                  {reportData.rc_tot
                    ? ((parseFloat(reportData.rc_nfsa_aay) * 100) / parseFloat(reportData.rc_tot)).toFixed(2) + '%'
                    : '0%'}
                </td>
              </tr>

              <tr>
                <td style={{ textAlign: 'center' }}>TOTAL NFSA RATION CARDS</td>
                <td style={{ textAlign: 'right' }}>{reportData.rc_tot}</td>
                <td style={{ textAlign: 'right' }}>
                  {reportData.rc_tot
                    ? ((parseFloat(reportData.rc_tot) * 100) / parseFloat(reportData.rc_tot)).toFixed(2) + '%'
                    : '0%'}
                </td>
              </tr>

              <tr className="tableheader">
                <td style={{ textAlign: 'center' }}>Commodities</td>
                <td style={{ textAlign: 'center' }}>Allocation (MTs)</td>
                <td style={{ textAlign: 'center' }}>Distribution (MTs)</td>
              </tr>

              {reportData.commoditycodeBean?.map((commodity, idx) => (
                <tr key={`commodity-${idx}`}>
                  <td>{commodity.comm_cd}</td>
                  <td style={{ textAlign: 'right' }}>{Number(commodity.allotment / 1000).toFixed(3) || 0}</td>
                  <td style={{ textAlign: 'right' }}>{Number(commodity.sale / 1000).toFixed(3) || 0}</td>
                </tr>
              ))}
              <tr>
                <td colSpan={3} style={{ textAlign: 'right', color: "red" }} >  Data refresh time : {reportData.ws_update_time.substring(0, 19)}</td>

              </tr>
            </React.Fragment>
          )}
        </tbody>

      </table>
      <br /><br /><br /><br />
      <div id="detailsERR" ref={detailsRRef}>{renderContentt}</div>
    </>
  );
};

export default AnnavitranTransReport;